import * as Router from '@rasa.io/utils.js/lib/router'
import {pipe, tap} from 'lodash/fp'
import * as React from 'react'
import {connect} from 'react-redux'
import * as ReactStrap from 'reactstrap'
import './styles.css'

export const preventDefaultThen = (fn: any) => pipe(
  tap((e: React.SyntheticEvent) => e.preventDefault()),
  fn,
)

export const stopPropagationThen = (fn: any) => pipe(
  tap((e: React.SyntheticEvent) => e.stopPropagation()),
  fn,
)

export const preventDefault = () => (e: React.SyntheticEvent) => e.preventDefault()

interface ComponentProps {
  children: any,
  href: string,
}
interface DispatchProps {push: (href: string) => Router.PushAction}
type Props = ComponentProps & DispatchProps
export const Link = connect(
  null,
  {push: Router.push},
)(({href, push, children, ...props}: Props) =>
<ReactStrap.Button {...props} onClick={preventDefaultThen(() => push(href))}>
  {children}
</ReactStrap.Button>)

type AnchorLinkProps = ComponentProps & DispatchProps & React.HTMLProps<HTMLAnchorElement>
export const AnchorLink = connect(
  null,
  {push: Router.push},
)(({href, push, children, ...props}: AnchorLinkProps) =>
<a {...props} href={href} onClick={preventDefaultThen(() => push(href))}>
  {children}
</a>)

export type AnchorButtonLinkProps = ReactStrap.ButtonProps
export const AnchorButtonLink = connect(
  null,
  {push: Router.push},
)(({href, push, children, ...props}: ReactStrap.ButtonProps) =>
<a href={href} onClick={preventDefaultThen(() => push(href))}>
  <ReactStrap.Button {...props}>
    {children}
  </ReactStrap.Button>
</a>)
